import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { ACTIVITY_TYPE } from "../../../common/Constants";

export const getTableConfigNOS = ({ userAccess, onShowDetail, onDelete, onPrint, dataTable }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <React.Fragment>{rowNumber}</React.Fragment>;
      },
      sort: false,
    },
  },
  {
    name: "tanggalFJB",
    label: "Tanggal FJB",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorFJB",
    label: "No FJB",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorPolisi",
    label: "No Polisi",
    options: {
      sort: false,
    },
  },
  {
    name: "namaPemilik",
    label: "Nama Pemilik",
    options: {
      sort: false,
    },
  },
  {
    name: "namaPembawa",
    label: "Nama Pembawa",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorMesin",
    label: "No Mesin",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorRangka",
    label: "No Rangka",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeVarian",
    label: "Kode Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeWarna",
    label: "Kode Warna",
    options: {
      sort: false,
    },
  },
  {
    name: "namaWarna",
    label: "Nama Warna",
    options: {
      sort: false,
    },
  },
  {
    name: "status",
    label: "Status",
    options: {
      sort: false,
    },
  },
  {
    name: "status",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        const {updateAccess, createAccess, deleteAccess} = userAccess || {};
        const inApproval = val === "WAITING_FOR_APPROVAL";

        const canEdit = val === "SUBMITTED"
        const canMelengkapi = val === "DRAFT";

        const isCompleted = val === "COMPLETED";

        const disableEdit = !canEdit || inApproval || isCompleted || !updateAccess;
        const disableMelengkapi = !canMelengkapi || inApproval || isCompleted || !createAccess;

        return (
          <FlexView hAlignContent="center" style={{ gap: "15px" }}>
            <SimpleButton
              id="btn_view"
              type="button"
              category="action_button"
              styles={{ width: "unset" }}
              icon={<i className="fa fa-lg fa-eye color-red" />}
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.VIEW)}
            />
            <SimpleButton
              id="btn_edit"
              category="action_button"
              type="button"
              disabled={disableEdit}
              styles={{ width: "unset" }}
              icon={<i className={`fa fa-lg fa-pencil-alt ${disableEdit? "color-grey": "color-red"}`} />}
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.UPDATE)}
            />
            <SimpleButton
              id="btn_melengkapi"
              category="action_button"
              type="button"
              disabled={disableMelengkapi}
              styles={{ width: "unset" }}
              icon={<i className={`fa fa-lg fa-file ${disableMelengkapi? "color-grey": "color-red"}`} />}
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.CORRECTION)}
            />
            <SimpleButton
              id="btn_delete"
              category="action_button"
              type="button"
              disabled={!deleteAccess}
              styles={{ width: "unset" }}
              icon={<i className={`fa fa-lg fa-trash ${!deleteAccess ? "color-grey" : "color-red"}`} />}
              onClick={() => onDelete(rowIndex, ACTIVITY_TYPE.DELETE)}
            />
            <SimpleButton
              id="btn_print"
              category="action_button"
              type="button"
              styles={{ width: "unset" }}
              icon={<i className="fa fa-lg fa-print color-red" />}
              onClick={() => onPrint(rowIndex)}
            />
          </FlexView>
        );
      },
    },
  },
];
